// extracted by mini-css-extract-plugin
export var compactFilters = "_fr-4";
export var detailImage = "_fr-1";
export var dropdownContainer = "_fr-2";
export var imageContainer = "_fr-0";
export var selectedCard = "_fr-3";